import script from "./BackToAdminButton.vue?vue&type=script&setup=true&lang=ts"
export * from "./BackToAdminButton.vue?vue&type=script&setup=true&lang=ts"

import "./BackToAdminButton.vue?vue&type=style&index=0&id=7d32c0f7&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7d32c0f7"]])

export default __exports__